/* app/js/src/components/publishing-status/publishing-grid/publishing-grid.component.scss */
.cursor-pointer {
  cursor: pointer;
}
@keyframes cs-pub-catalog-overlay-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
:host {
  display: block;
  width: 100%;
}
.publishing-table-wrapper {
  width: 100%;
  padding: 0 0 24px;
}
.publishing-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  background-color: rgb(255, 255, 255);
}
.publishing-table thead {
  position: relative;
  z-index: 2;
}
.publishing-table__th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 7px 15px 5px 20px;
  text-align: left;
  vertical-align: bottom;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: rgb(255, 255, 255);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  line-height: normal;
  color: rgba(0, 0, 0, 0.85);
  text-transform: uppercase;
  white-space: nowrap;
}
.publishing-table__th--checkbox {
  width: 44px;
  text-align: center;
  padding-left: 12px;
  padding-right: 8px;
}
.publishing-table__th--preview {
  width: 112px;
}
.publishing-table__th--title {
  width: 22%;
}
.publishing-table__th--platform {
  width: 14%;
}
.publishing-table__th--destination {
  width: 18%;
}
.publishing-table__th--date {
  width: 14%;
}
.publishing-table__th--status {
  width: 16%;
}
.publishing-table__th--actions {
  width: 104px;
  text-align: center;
}
.publishing-table__empty-row:hover {
  background-color: transparent;
}
.publishing-table__empty {
  padding: 48px 24px;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
.publishing-table__empty p {
  margin: 0;
}
/*# sourceMappingURL=publishing-grid.component.css.map */
